// import React, { useState, useEffect } from "react";
// import "./NewPatientRegistration.css";

// const theme = {
//   primaryDark: "#1b325f", primaryBlue: "#282f81", accentCyan: "#11abea",
//   bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
//   textMuted: "#64748b", borderLight: "#e2e8f0"
// };

// // --- ERP COMPACT STYLES ---
// const compactRowStyle = { display: 'flex', alignItems: 'center', marginBottom: '4px' };
//   const compactLabelStyle = { width: '95px', fontSize: '12px', color: theme.textMain, fontWeight: '600' };

//   // Table Cell Styles
//   const cellStyle = { border: `1px solid ${theme.borderLight}`, padding: '0', margin: '0' };
//   const cellInputStyle = { width: '100%', boxSizing: 'border-box', border: 'none', padding: '6px', fontSize: '12px', backgroundColor: 'transparent', outline: 'none' };

// const PurchaseOrderMedicines = ({ screenAction, triggerSave }) => {
//   const initHeader = {
//     po_number: "", supplier_name: "", invoice_number: "", invoice_date: "", payment_mode: "",
//     total_purchase_amount: 0, total_discount_amount: 0, total_gst_amount: 0, net_amount: 0
//   };

//   const initLine = {
//     medicine_id: "", medicine_name: "", unit: "Box", quantity: "", free_quantity: "",
//     purchase_rate: "", purchase_amount: 0, mrp: "", discount_percent: "", discount_amount: 0,
//     gst_percent: "", gst_amount: 0, expiry_date: "", line_total: 0
//   };

//   const [header, setHeader] = useState(initHeader);
//   const [lines, setLines] = useState([initLine]);
  
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   const [suppliersList, setSuppliersList] = useState([]);
//   const [medicinesList, setMedicinesList] = useState([]);

//   const compactInputStyle = { 
//     flex: 1, padding: '6px 8px', fontSize: '12px', border: 'none', 
//     borderBottom: `1px solid ${theme.borderLight}`, outline: 'none', 
//     backgroundColor: isDisabled ? 'transparent' : '#fcfcfc' 
//   };

//   // --- DATA FETCHING ---
//   const fetchBaseData = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     try {
//       const [supRes, medRes] = await Promise.all([
//         fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliers?employee_id=${user.id}`),
//         fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicines/all?employee_id=${user.id}`)
//       ]);
//       const supData = await supRes.json();
//       const medData = await medRes.json();
//       setSuppliersList(Array.isArray(supData) ? supData : []);
//       setMedicinesList(Array.isArray(medData) ? medData : []);
//     } catch (e) { console.error("Error loading base data", e); }
//   };

//   const fetchNextId = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/medicine-po/id?employee_id=${user.id}`);
//     const data = await res.json();
//     setHeader(prev => ({ ...prev, po_number: data.po_number }));
//   };

//   useEffect(() => { fetchBaseData(); fetchNextId(); }, []);

//   // --- CALCULATIONS ---
//   // Recalculate totals whenever lines change
//   useEffect(() => {
//     let t_pur = 0, t_disc = 0, t_gst = 0, t_net = 0;
//     lines.forEach(l => {
//       t_pur += parseFloat(l.purchase_amount) || 0;
//       t_disc += parseFloat(l.discount_amount) || 0;
//       t_gst += parseFloat(l.gst_amount) || 0;
//       t_net += parseFloat(l.line_total) || 0;
//     });
//     setHeader(prev => ({
//       ...prev,
//       total_purchase_amount: t_pur.toFixed(2),
//       total_discount_amount: t_disc.toFixed(2),
//       total_gst_amount: t_gst.toFixed(2),
//       net_amount: t_net.toFixed(2)
//     }));
//   }, [lines]);

//   const handleHeaderChange = (e) => setHeader({ ...header, [e.target.name]: e.target.value });

//   const handleLineChange = (index, field, value) => {
//     const updated = [...lines];
//     const row = updated[index];
//     row[field] = value;

//     // Auto-fill medicine details
//     if (field === "medicine_id") {
//       const med = medicinesList.find(m => m.medicine_id === value);
//       if (med) {
//         row.medicine_name = med.medicine_name;
//         row.purchase_rate = med.purchase_price;
//         row.mrp = med.mrp;
//         row.gst_percent = med.gst_percentage;
//       } else {
//         row.medicine_name = ""; row.purchase_rate = ""; row.mrp = ""; row.gst_percent = "";
//       }
//     }

//     // Auto Calculations
//     const qty = parseFloat(row.quantity) || 0;
//     const rate = parseFloat(row.purchase_rate) || 0;
//     const discPct = parseFloat(row.discount_percent) || 0;
//     const gstPct = parseFloat(row.gst_percent) || 0;

//     row.purchase_amount = (qty * rate).toFixed(2);
//     row.discount_amount = (row.purchase_amount * (discPct / 100)).toFixed(2);
    
//     const taxableAmount = row.purchase_amount - row.discount_amount;
//     row.gst_amount = (taxableAmount * (gstPct / 100)).toFixed(2);
//     row.line_total = (taxableAmount + parseFloat(row.gst_amount)).toFixed(2);

//     updated[index] = row;
//     setLines(updated);
//   };

//   const addRow = () => setLines([...lines, { ...initLine }]);
//   const removeRow = (index) => setLines(lines.filter((_, i) => i !== index));

//   // --- SEARCH & MODES ---
//   const searchPO = async (text) => {
//     setSearchText(text);
//     if (text.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
//     const user = JSON.parse(localStorage.getItem("user"));
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/search?q=${text}&employee_id=${user.id}`);
//     setSearchResults(await res.json());
//     setShowDropdown(true);
//   };

//   const selectPO = async (po) => {
//     setSearchText(`${po.po_number} | ${po.supplier_name}`);
//     setShowDropdown(false);
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/${po.po_number}`);
//     const data = await res.json();
    
//     if(data.header) {
//       setHeader({ ...data.header, invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" });
//       setLines(data.details.length > 0 ? data.details.map(d => ({...d, expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""})) : [initLine]);
//     }
    
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };

//   const clearForm = async () => {
//     setHeader(initHeader); setLines([initLine]); setSearchText("");
//     await fetchNextId();
//   };

//   useEffect(() => {
//     if (screenAction === "add" || screenAction === "refresh") { clearForm(); setIsDisabled(false); }
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//     if (screenAction === "print") printForm();
//   }, [screenAction]);

//   useEffect(() => { if (triggerSave > 0 && screenAction === "save") handleSubmit(); }, [triggerSave]);

//   const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!header.supplier_name) return alert("Supplier is required.");
//     if (lines.length === 0 || !lines[0].medicine_id) return alert("Add at least one medicine line item.");

//     const payload = { header: { ...header, created_by: user.id }, details: lines, isEdit: !!header.created_at };
    
//     try {
//       const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po", {
//         method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
//       });
//       if (res.ok) {
//         alert("Purchase Order Saved!");
//         if (!payload.isEdit) clearForm();
//       } else alert("Error saving PO");
//     } catch (err) { alert("Network Error"); }
//   };

//   // --- PRINT FORM ---
//   const printForm = () => {
//     if (!header.po_number) return;
//     const newWindow = window.open("", "", "width=1000,height=800");
    
//     const htmlContent = `
//       <html><head><title>PO - ${header.po_number}</title>
//       <style>
//         body { font-family: 'Segoe UI', Tahoma, sans-serif; padding: 30px; font-size: 13px; color: #333; }
//         .title-box { display: flex; justify-content: space-between; border-bottom: 2px solid #282f81; padding-bottom: 10px; margin-bottom: 20px; }
//         .title-box h1 { margin: 0; color: #282f81; }
//         .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px; }
//         table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
//         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//         th { background-color: #f2f4f4; color: #282f81; }
//         .totals-box { width: 300px; float: right; border: 1px solid #ddd; padding: 10px; border-radius: 4px; }
//         .totals-row { display: flex; justify-content: space-between; margin-bottom: 5px; }
//         .grand-total { font-weight: bold; font-size: 16px; border-top: 1px solid #ccc; padding-top: 5px; color: #11abea; }
//       </style></head>
//       <body>
//         <div class="title-box">
//           <div><h1>EMEDHA CARE HOSPITAL</h1><p>Pharmacy Purchase Order</p></div>
//           <div style="text-align:right"><h2>${header.po_number}</h2><p>Date: ${new Date().toLocaleDateString()}</p></div>
//         </div>
//         <div class="info-grid">
//           <div><strong>Supplier:</strong> ${header.supplier_name}<br/><strong>Payment Mode:</strong> ${header.payment_mode}</div>
//           <div><strong>Invoice No:</strong> ${header.invoice_number}<br/><strong>Invoice Date:</strong> ${header.invoice_date}</div>
//         </div>
//         <table>
//           <thead><tr><th>Medicine Name</th><th>Unit</th><th>Qty</th><th>Free</th><th>Rate</th><th>MRP</th><th>Disc%</th><th>GST%</th><th>Total</th></tr></thead>
//           <tbody>
//             ${lines.map(l => `<tr><td>${l.medicine_name}</td><td>${l.unit}</td><td>${l.quantity}</td><td>${l.free_quantity}</td>
//               <td>₹${l.purchase_rate}</td><td>₹${l.mrp}</td><td>${l.discount_percent}%</td><td>${l.gst_percent}%</td><td>₹${l.line_total}</td></tr>`).join('')}
//           </tbody>
//         </table>
//         <div class="totals-box">
//           <div class="totals-row"><span>Purchase Amount:</span><span>₹${header.total_purchase_amount}</span></div>
//           <div class="totals-row"><span>Discount Amount:</span><span>₹${header.total_discount_amount}</span></div>
//           <div class="totals-row"><span>GST Amount:</span><span>₹${header.total_gst_amount}</span></div>
//           <div class="totals-row grand-total"><span>Net Amount:</span><span>₹${header.net_amount}</span></div>
//         </div>
//       </body></html>
//     `;
//     newWindow.document.write(htmlContent); newWindow.document.close();
//     setTimeout(() => { newWindow.print(); newWindow.close(); }, 500);
//   };

//   return (
//     <div className="registration-container fade-in" style={{ backgroundColor: theme.bgLight, padding: '10px' }}>
      
//       {(screenAction === "edit" || screenAction === "view") && (
//         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
//           <div style={{ position: 'relative', width: '350px' }}>
//             <input type="text" value={searchText} placeholder="Search PO No, Supplier, Invoice..." onChange={(e) => searchPO(e.target.value)}
//               style={{ width: '100%', padding: '10px 16px', borderRadius: '8px', border: `1px solid ${theme.borderLight}`, outline: 'none' }} />
//             {showDropdown && searchResults.length > 0 && (
//               <div style={{ position: 'absolute', top: '110%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '250px', overflowY: 'auto' }}>
//                 {searchResults.map(p => (
//                   <div key={p.po_number} onClick={() => selectPO(p)} style={{ padding: '10px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer' }}>
//                     <strong>{p.po_number}</strong> <br/><span style={{ fontSize: '12px', color: theme.textMuted }}>{p.supplier_name} | {p.invoice_number}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <form className="luxury-form" style={{ padding: '20px' }}>
        
//         {/* HEADER SECTION */}

//         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '20px', padding: '10px 0', borderBottom: `2px solid ${theme.primaryDark}`, marginBottom: '10px' }}>
          
//           {/* Column 1: PO & Supplier */}
//           <div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>PO Number:</div>
//               <input type="text" name="po_number" value={header.po_number} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Supplier Name:</div>
//               <select name="supplier_name" value={header.supplier_name} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
//                 <option value="">Select Supplier...</option>
//                 {suppliersList.map((s, i) => <option key={i} value={s.Supp_Nm}>{s.Supp_Nm}</option>)}
//               </select>
//             </div>
//           </div>

//           {/* Column 2: Invoice Details */}
//           <div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Invoice No:</div>
//               <input type="text" name="invoice_number" value={header.invoice_number} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Invoice Date:</div>
//               <input type="date" name="invoice_date" value={header.invoice_date} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
//             </div>
//           </div>

//           {/* Column 3: Payment & Purchase Amt */}
//           <div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Payment Mode:</div>
//               <select name="payment_mode" value={header.payment_mode} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
//                 <option value="">Select</option><option>Cash</option><option>Card</option><option>UPI</option><option>Credit</option>
//               </select>
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Purchase Amt:</div>
//               <input type="text" value={header.total_purchase_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//           </div>

//           {/* Column 4: Remaining Totals */}
//           <div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Discount Amt:</div>
//               <input type="text" value={header.total_discount_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>GST Amt:</div>
//               <input type="text" value={header.total_gst_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Net Amount:</div>
//               <input type="text" value={header.net_amount} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue, backgroundColor: '#e0e7ff'}} />
//             </div>
//           </div>

//         </div>

//         {/* LINE ITEMS SECTION */}
//         <div className="form-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <h3>Line Items</h3>
//           {!isDisabled && <button type="button" onClick={addRow} style={{ background: theme.primaryBlue, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>+ Add Row</button>}
//         </div>
        
//         <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
//           <table style={{ width: '100%', minWidth: '1200px', borderCollapse: 'collapse', fontSize: '12px' }}>
//             <thead style={{ backgroundColor: theme.primaryDark, color: '#fff' }}>
//               <tr>
//                 <th style={{ padding: '8px' }}>Medicine ID</th><th style={{ padding: '8px' }}>Medicine Name</th>
//                 <th style={{ padding: '8px', width:'70px' }}>Unit</th><th style={{ padding: '8px', width:'70px' }}>Qty</th><th style={{ padding: '8px', width:'70px' }}>Free</th>
//                 <th style={{ padding: '8px', width:'80px' }}>Rate</th><th style={{ padding: '8px', width:'80px' }}>MRP</th>
//                 <th style={{ padding: '8px', width:'70px' }}>Disc%</th><th style={{ padding: '8px', width:'70px' }}>GST%</th>
//                 <th style={{ padding: '8px', width:'120px' }}>Expiry</th><th style={{ padding: '8px', width:'100px' }}>Line Total</th>
//                 {!isDisabled && <th style={{ padding: '8px', width:'40px' }}></th>}
//               </tr>
//             </thead>
//             <tbody>
//               {lines.map((line, idx) => (
//                 <tr key={idx} style={{ borderBottom: `1px solid ${theme.borderLight}` }}>
//                   <td style={{ padding: '4px' }}>
//                     <select value={line.medicine_id} onChange={(e) => handleLineChange(idx, 'medicine_id', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }}>
//                       <option value="">Select</option>
//                       {medicinesList.map(m => <option key={m.medicine_id} value={m.medicine_id}>{m.medicine_id}</option>)}
//                     </select>
//                   </td>
//                   <td style={{ padding: '4px' }}><input type="text" value={line.medicine_name} disabled style={{ width: '100%', padding: '4px', border: 'none', background: 'transparent' }} /></td>
//                   <td style={{ padding: '4px' }}>
//                     <select value={line.unit} onChange={(e) => handleLineChange(idx, 'unit', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }}>
//                       <option>Box</option><option>Strip</option><option>Loose</option>
//                     </select>
//                   </td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.quantity} onChange={(e) => handleLineChange(idx, 'quantity', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.free_quantity} onChange={(e) => handleLineChange(idx, 'free_quantity', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.purchase_rate} onChange={(e) => handleLineChange(idx, 'purchase_rate', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.mrp} onChange={(e) => handleLineChange(idx, 'mrp', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.discount_percent} onChange={(e) => handleLineChange(idx, 'discount_percent', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="number" value={line.gst_percent} onChange={(e) => handleLineChange(idx, 'gst_percent', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px' }}><input type="date" value={line.expiry_date} onChange={(e) => handleLineChange(idx, 'expiry_date', e.target.value)} disabled={isDisabled} style={{ width: '100%', padding: '4px', border: '1px solid #ccc', borderRadius: '4px' }} /></td>
//                   <td style={{ padding: '4px', fontWeight: 'bold', color: theme.primaryBlue }}>₹{line.line_total}</td>
//                   {!isDisabled && <td style={{ padding: '4px', textAlign: 'center' }}><button type="button" onClick={() => removeRow(idx)} style={{ color: 'red', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 'bold' }}>X</button></td>}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>


// {/* TOTALS SECTION */}
//         <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//           <div style={{ width: '280px', fontSize: '13px', color: theme.primaryDark }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
//               <span style={{ fontWeight: '600' }}>Purchase Amt:</span> <span>₹{header.total_purchase_amount}</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
//               <span style={{ fontWeight: '600' }}>Discount Amt:</span> <span>₹{header.total_discount_amount}</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
//               <span style={{ fontWeight: '600' }}>GST Amt:</span> <span>₹{header.total_gst_amount}</span>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderTop: `2px solid ${theme.primaryBlue}`, color: theme.primaryBlue, fontSize: '15px' }}>
//               <span style={{ fontWeight: '800' }}>Net Amount:</span> <span style={{ fontWeight: '800' }}>₹{header.net_amount}</span>
//             </div>
//           </div>
//         </div>

//       </form>
//     </div>
//   );
// };

// export default PurchaseOrderMedicines;

// import React, { useState, useEffect } from "react";
// import "./NewPatientRegistration.css";

// const theme = {
//   primaryDark: "#1b325f", primaryBlue: "#282f81", accentCyan: "#11abea",
//   bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
//   textMuted: "#64748b", borderLight: "#e2e8f0"
// };

// const PurchaseOrderMedicines = ({ screenAction, triggerSave }) => {
//   const initHeader = {
//     po_number: "", supplier_name: "", invoice_number: "", invoice_date: "", payment_mode: "",
//     total_purchase_amount: 0, total_discount_amount: 0, total_gst_amount: 0, net_amount: 0
//   };

//   const initLine = {
//     medicine_id: "", medicine_name: "", unit: "Box", quantity: "", free_quantity: "",
//     purchase_rate: "", purchase_amount: 0, mrp: "", discount_percent: "", discount_amount: 0,
//     gst_percent: "", gst_amount: 0, expiry_date: "", line_total: 0
//   };

//   const [header, setHeader] = useState(initHeader);
//   const [lines, setLines] = useState([initLine]);
  
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
  
//   const [suppliersList, setSuppliersList] = useState([]);
//   const [medicinesList, setMedicinesList] = useState([]);

//   // --- ERP COMPACT STYLES ---
//   const compactRowStyle = { display: 'flex', alignItems: 'center', marginBottom: '6px' };
//   const compactLabelStyle = { width: '100px', fontSize: '12px', color: theme.textMain, fontWeight: '600' };
//   const compactInputStyle = { 
//     flex: 1, padding: '4px 6px', fontSize: '12px', border: 'none', 
//     borderBottom: `1px solid ${theme.borderLight}`, outline: 'none', 
//     backgroundColor: isDisabled ? 'transparent' : '#fcfcfc' 
//   };

//   // Table Cell Styles
//   const cellStyle = { border: `1px solid ${theme.borderLight}`, padding: '0', margin: '0' };
//   const cellInputStyle = { width: '100%', boxSizing: 'border-box', border: 'none', padding: '6px 4px', fontSize: '11px', backgroundColor: 'transparent', outline: 'none' };
//   const readOnlyCell = { ...cellInputStyle, backgroundColor: '#f1f5f9', fontWeight: '600', color: theme.textMain };

//   // --- DATA FETCHING ---
//   const fetchBaseData = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     try {
//       const [supRes, medRes] = await Promise.all([
//         fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliers?employee_id=${user.id}`),
//         fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicines/all?employee_id=${user.id}`)
//       ]);
//       const supData = await supRes.json();
//       const medData = await medRes.json();
//       setSuppliersList(Array.isArray(supData) ? supData : []);
//       setMedicinesList(Array.isArray(medData) ? medData : []);
//     } catch (e) { console.error("Error loading base data", e); }
//   };

//   const fetchNextId = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/medicine-po/id?employee_id=${user.id}`);
//     const data = await res.json();
//     setHeader(prev => ({ ...prev, po_number: data.po_number }));
//   };

//   useEffect(() => { fetchBaseData(); fetchNextId(); }, []);

//   // --- CALCULATIONS ---
//   // Recalculate totals whenever lines change
//   useEffect(() => {
//     let t_pur = 0, t_disc = 0, t_gst = 0, t_net = 0;
//     lines.forEach(l => {
//       t_pur += parseFloat(l.purchase_amount) || 0;
//       t_disc += parseFloat(l.discount_amount) || 0;
//       t_gst += parseFloat(l.gst_amount) || 0;
//       t_net += parseFloat(l.line_total) || 0;
//     });
//     setHeader(prev => ({
//       ...prev,
//       total_purchase_amount: t_pur.toFixed(2),
//       total_discount_amount: t_disc.toFixed(2),
//       total_gst_amount: t_gst.toFixed(2),
//       net_amount: t_net.toFixed(2)
//     }));
//   }, [lines]);

//   const handleHeaderChange = (e) => setHeader({ ...header, [e.target.name]: e.target.value });

//   const handleLineChange = (index, field, value) => {
//     const updated = [...lines];
//     const row = updated[index];
//     row[field] = value;

//     // Auto-fill medicine details
//     if (field === "medicine_id") {
//       const med = medicinesList.find(m => m.medicine_id === value);
//       if (med) {
//         row.medicine_name = med.medicine_name;
//         row.purchase_rate = med.purchase_price;
//         row.mrp = med.mrp;
//         row.gst_percent = med.gst_percentage;
//       } else {
//         row.medicine_name = ""; row.purchase_rate = ""; row.mrp = ""; row.gst_percent = "";
//       }
//     }

//     // Auto Calculations
//     const qty = parseFloat(row.quantity) || 0;
//     const rate = parseFloat(row.purchase_rate) || 0;
//     const discPct = parseFloat(row.discount_percent) || 0;
//     const gstPct = parseFloat(row.gst_percent) || 0;

//     row.purchase_amount = (qty * rate).toFixed(2);
//     row.discount_amount = (row.purchase_amount * (discPct / 100)).toFixed(2);
    
//     const taxableAmount = row.purchase_amount - row.discount_amount;
//     row.gst_amount = (taxableAmount * (gstPct / 100)).toFixed(2);
//     row.line_total = (taxableAmount + parseFloat(row.gst_amount)).toFixed(2);

//     updated[index] = row;
//     setLines(updated);
//   };

//   const addRow = () => setLines([...lines, { ...initLine }]);
//   const removeRow = (index) => setLines(lines.filter((_, i) => i !== index));

//   // --- SEARCH & MODES ---
//   const searchPO = async (text) => {
//     setSearchText(text);
//     if (text.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
//     const user = JSON.parse(localStorage.getItem("user"));
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/search?q=${text}&employee_id=${user.id}`);
//     setSearchResults(await res.json());
//     setShowDropdown(true);
//   };

//   const selectPO = async (po) => {
//     setSearchText(`${po.po_number} | ${po.supplier_name}`);
//     setShowDropdown(false);
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/${po.po_number}`);
//     const data = await res.json();
    
//     if(data.header) {
//       setHeader({ ...data.header, invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" });
//       setLines(data.details.length > 0 ? data.details.map(d => ({...d, expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""})) : [initLine]);
//     }
    
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };

//   const clearForm = async () => {
//     setHeader(initHeader); setLines([initLine]); setSearchText("");
//     await fetchNextId();
//   };

//   useEffect(() => {
//     if (screenAction === "add" || screenAction === "refresh") { clearForm(); setIsDisabled(false); }
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//     if (screenAction === "print") printForm();
//   }, [screenAction]);

//   useEffect(() => { if (triggerSave > 0 && screenAction === "save") handleSubmit(); }, [triggerSave]);

// const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!header.supplier_name) return alert("Supplier is required.");
    
//     // Filter out completely empty rows before saving
//     const validLines = lines.filter(l => l.medicine_id !== "");
//     if (validLines.length === 0) return alert("Add at least one medicine line item.");

//     const payload = { header: { ...header, created_by: user.id }, details: validLines, isEdit: !!header.created_at };
    
//     try {
//       const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po", {
//         method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
//       });
//       if (res.ok) {
//         alert("Purchase Order Saved!");
//         if (!payload.isEdit) clearForm();
//       } else alert("Error saving PO");
//     } catch (err) { alert("Network Error"); }
//   };

//   // --- PRINT FORM ---
// // --- PRINT FORM ---
//   const printForm = () => {
//     if (!header.po_number) return;
//     const newWindow = window.open("", "", "width=1100,height=800");
    
//     const htmlContent = `
//       <html><head><title>PO - ${header.po_number}</title>
//       <style>
//         body { font-family: 'Segoe UI', Tahoma, sans-serif; padding: 30px; font-size: 12px; color: #333; }
//         .title-box { display: flex; justify-content: space-between; border-bottom: 2px solid #282f81; padding-bottom: 10px; margin-bottom: 20px; }
//         .title-box h1 { margin: 0; color: #282f81; }
//         .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px; margin-bottom: 20px; }
//         table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 11px; }
//         th, td { border: 1px solid #ddd; padding: 6px 4px; text-align: left; }
//         th { background-color: #f2f4f4; color: #282f81; }
//         .totals-box { width: 300px; float: right; border: 1px solid #ddd; padding: 10px; border-radius: 4px; }
//         .totals-row { display: flex; justify-content: space-between; margin-bottom: 5px; }
//         .grand-total { font-weight: bold; font-size: 14px; border-top: 1px solid #ccc; padding-top: 5px; color: #11abea; }
//       </style></head>
//       <body>
//         <div class="title-box">
//           <div><h1>EMEDHA CARE HOSPITAL</h1><p>Pharmacy Purchase Order</p></div>
//           <div style="text-align:right"><h2>${header.po_number}</h2><p>Date: ${new Date().toLocaleDateString()}</p></div>
//         </div>
//         <div class="info-grid">
//           <div><strong>Supplier:</strong><br/>${header.supplier_name}</div>
//           <div><strong>Invoice No / Date:</strong><br/>${header.invoice_number || '-'} / ${header.invoice_date || '-'}</div>
//           <div><strong>Payment Mode:</strong><br/>${header.payment_mode || '-'}</div>
//         </div>
//         <table>
//           <thead>
//             <tr>
//               <th>SI</th><th>Medicine Name</th><th>Unit</th><th>Qty</th><th>Free</th>
//               <th>Pur Rate</th><th>Pur Amt</th><th>MRP</th><th>Disc%</th><th>Disc Amt</th>
//               <th>GST%</th><th>GST Amt</th><th>Expiry</th><th>Line Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${lines.map((l, i) => `
//               <tr>
//                 <td>${i + 1}</td><td>${l.medicine_name}</td><td>${l.unit}</td><td>${l.quantity}</td><td>${l.free_quantity}</td>
//                 <td>₹${l.purchase_rate}</td><td>₹${l.purchase_amount}</td><td>₹${l.mrp}</td><td>${l.discount_percent}%</td><td>₹${l.discount_amount}</td>
//                 <td>${l.gst_percent}%</td><td>₹${l.gst_amount}</td><td>${l.expiry_date}</td><td><strong>₹${l.line_total}</strong></td>
//               </tr>
//             `).join('')}
//           </tbody>
//         </table>
//         <div class="totals-box">
//           <div class="totals-row"><span>Total Purchase Amt:</span><span>₹${header.total_purchase_amount}</span></div>
//           <div class="totals-row"><span>Total Discount Amt:</span><span>₹${header.total_discount_amount}</span></div>
//           <div class="totals-row"><span>Total GST Amt:</span><span>₹${header.total_gst_amount}</span></div>
//           <div class="totals-row grand-total"><span>Net Amount:</span><span>₹${header.net_amount}</span></div>
//         </div>
//       </body></html>
//     `;
//     newWindow.document.write(htmlContent); newWindow.document.close();
//     setTimeout(() => { newWindow.print(); newWindow.close(); }, 500);
//   };


  

//   return (
//     <div className="registration-container fade-in" style={{ backgroundColor: theme.bgLight, padding: '10px' }}>
      
//       {/* TOP SEARCH BAR */}
//       {(screenAction === "edit" || screenAction === "view") && (
//         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
//           <div style={{ position: 'relative', width: '350px' }}>
//             <input type="text" value={searchText} placeholder="Search PO No, Supplier, Invoice..." onChange={(e) => searchPO(e.target.value)}
//               style={{ width: '100%', padding: '10px 16px', borderRadius: '8px', border: `1px solid ${theme.borderLight}`, outline: 'none' }} />
//             {showDropdown && searchResults.length > 0 && (
//               <div style={{ position: 'absolute', top: '110%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '250px', overflowY: 'auto' }}>
//                 {searchResults.map(p => (
//                   <div key={p.po_number} onClick={() => selectPO(p)} style={{ padding: '10px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer' }}>
//                     <strong>{p.po_number}</strong> <br/><span style={{ fontSize: '12px', color: theme.textMuted }}>{p.supplier_name} | {p.invoice_number}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <form className="luxury-form" style={{ padding: '15px 20px' }}>
        
//         {/* HEADER SECTION (Compact 4-Column ERP Style with Totals Included) */}
//   {/* HEADER SECTION (Responsive ERP Style with Totals) */}
//         <div style={{ 
//           display: 'grid', 
//           gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', /* This line makes it responsive! */
//           gap: '20px', 
//           paddingBottom: '15px', 
//           borderBottom: `2px solid ${theme.primaryDark}`, 
//           marginBottom: '15px' 
//         }}>
          
//           {/* Column 1: PO & Supplier */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>PO Number:</div>
//               <input type="text" name="po_number" value={header.po_number} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Supplier Name:</div>
//               <select name="supplier_name" value={header.supplier_name} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
//                 <option value="">Select Supplier...</option>
//                 {suppliersList.map((s, i) => <option key={i} value={s.Supp_Nm}>{s.Supp_Nm}</option>)}
//               </select>
//             </div>
//           </div>

//           {/* Column 2: Invoice Details */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Invoice No:</div>
//               <input type="text" name="invoice_number" value={header.invoice_number} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Invoice Date:</div>
//               <input type="date" name="invoice_date" value={header.invoice_date} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
//             </div>
//           </div>

//           {/* Column 3: Payment & Purchase Amt */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Payment Mode:</div>
//               <select name="payment_mode" value={header.payment_mode} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
//                 <option value="">Select</option><option>Cash</option><option>Card</option><option>UPI</option><option>Credit</option>
//               </select>
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Purchase Amt:</div>
//               <input type="text" value={header.total_purchase_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//           </div>

//           {/* Column 4: Remaining Totals */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Discount Amt:</div>
//               <input type="text" value={header.total_discount_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>GST Amt:</div>
//               <input type="text" value={header.total_gst_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9'}} />
//             </div>
//             <div style={compactRowStyle}>
//               <div style={compactLabelStyle}>Net Amount:</div>
//               <input type="text" value={header.net_amount} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue, backgroundColor: '#e0e7ff'}} />
//             </div>
//           </div>

//         </div>

//         {/* LINE ITEMS SECTION */}
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//           <h3 style={{ margin: 0, fontSize: '15px', color: theme.primaryDark }}>Line Items</h3>
//           {!isDisabled && <button type="button" onClick={addRow} style={{ background: theme.primaryBlue, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>+ Add Row</button>}
//         </div>
        
//         <div style={{ overflowX: 'auto', border: `1px solid ${theme.borderLight}`, marginBottom: '10px' }}>
//           <table style={{ width: '100%', minWidth: '1500px', borderCollapse: 'collapse', fontSize: '11px' }}>
//             <thead style={{ backgroundColor: theme.primaryDark, color: '#fff' }}>
//               <tr>
//                 <th style={{ ...cellStyle, padding: '6px', width: '30px', textAlign: 'center' }}>SI</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '100px' }}>Medicine ID</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '160px' }}>Medicine Name</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '60px' }}>Unit</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>Qty</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>Free Qty</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>Pur Rate</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '80px' }}>Pur Amt</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '60px' }}>MRP</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>Disc%</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>Disc Amt</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>GST%</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>GST Amt</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '110px' }}>Expiry Dt</th>
//                 <th style={{ ...cellStyle, padding: '6px', width: '90px' }}>Line Total</th>
//                 {!isDisabled && <th style={{ ...cellStyle, width: '30px' }}></th>}
//               </tr>
//             </thead>
//             <tbody>
//               {lines.map((line, idx) => (
//                 <tr key={idx} style={{ borderBottom: `1px solid ${theme.borderLight}` }}>
//                   <td style={{ ...cellStyle, textAlign: 'center', fontWeight: 'bold' }}>{idx + 1}</td>
                  
//                   <td style={cellStyle}>
//                     <select value={line.medicine_id} onChange={(e) => handleLineChange(idx, 'medicine_id', e.target.value)} disabled={isDisabled} style={cellInputStyle}>
//                       <option value=""></option>
//                       {medicinesList.map(m => <option key={m.medicine_id} value={m.medicine_id}>{m.medicine_id}</option>)}
//                     </select>
//                   </td>
                  
//                   <td style={cellStyle}><input type="text" value={line.medicine_name} disabled style={readOnlyCell} title={line.medicine_name} /></td>
                  
//                   <td style={cellStyle}>
//                     <select value={line.unit} onChange={(e) => handleLineChange(idx, 'unit', e.target.value)} disabled={isDisabled} style={cellInputStyle}>
//                       <option>Box</option><option>Strip</option><option>Loose</option>
//                     </select>
//                   </td>
                  
//                   <td style={cellStyle}><input type="number" value={line.quantity} onChange={(e) => handleLineChange(idx, 'quantity', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
//                   <td style={cellStyle}><input type="number" value={line.free_quantity} onChange={(e) => handleLineChange(idx, 'free_quantity', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
//                   <td style={cellStyle}><input type="number" value={line.purchase_rate} onChange={(e) => handleLineChange(idx, 'purchase_rate', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  
//                   <td style={cellStyle}><input type="text" value={line.purchase_amount} disabled style={readOnlyCell} /></td>
                  
//                   <td style={cellStyle}><input type="number" value={line.mrp} onChange={(e) => handleLineChange(idx, 'mrp', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
//                   <td style={cellStyle}><input type="number" value={line.discount_percent} onChange={(e) => handleLineChange(idx, 'discount_percent', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  
//                   <td style={cellStyle}><input type="text" value={line.discount_amount} disabled style={readOnlyCell} /></td>
                  
//                   <td style={cellStyle}><input type="number" value={line.gst_percent} onChange={(e) => handleLineChange(idx, 'gst_percent', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  
//                   <td style={cellStyle}><input type="text" value={line.gst_amount} disabled style={readOnlyCell} /></td>
                  
//                   <td style={cellStyle}><input type="date" value={line.expiry_date} onChange={(e) => handleLineChange(idx, 'expiry_date', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  
//                   <td style={cellStyle}><input type="text" value={line.line_total} disabled style={{...readOnlyCell, color: theme.primaryBlue}} /></td>
                  
//                   {!isDisabled && <td style={{ ...cellStyle, textAlign: 'center' }}><button type="button" onClick={() => removeRow(idx)} style={{ color: 'red', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 'bold' }}>X</button></td>}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default PurchaseOrderMedicines;

import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const theme = {
  primaryDark: "#1b325f", primaryBlue: "#282f81", accentCyan: "#11abea",
  bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
  textMuted: "#64748b", borderLight: "#e2e8f0"
};

const PurchaseOrderMedicines = ({ screenAction, triggerSave }) => {
  const initHeader = {
    po_number: "", indent_number: "", supplier_name: "", invoice_number: "", invoice_date: "", payment_mode: "",
    total_purchase_amount: 0, total_discount_amount: 0, total_gst_amount: 0, net_amount: 0, po_status: "Pending"
  };

  const initLine = {
    medicine_id: "", medicine_name: "", unit: "Box", 
    indent_qty: "", max_allowed_qty: null, // 🔥 New fields for tracking limits
    quantity: "", free_quantity: "",
    purchase_rate: "", purchase_amount: 0, mrp: "", discount_percent: "", discount_amount: 0,
    gst_percent: "", gst_amount: 0, expiry_date: "", line_total: 0
  };

  const [header, setHeader] = useState(initHeader);
  const [lines, setLines] = useState([initLine]);
  
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  
  const [suppliersList, setSuppliersList] = useState([]);
  const [medicinesList, setMedicinesList] = useState([]);
  const [pendingIndents, setPendingIndents] = useState([]);


  const [isApproveMode, setIsApproveMode] = useState(false); // 🔥 Add this



  const compactRowStyle = { display: 'flex', alignItems: 'center', marginBottom: '6px' };
  const compactLabelStyle = { width: '100px', fontSize: '12px', color: theme.textMain, fontWeight: '600' };
  const compactInputStyle = { 
    flex: 1, padding: '4px 6px', fontSize: '12px', border: 'none', 
    borderBottom: `1px solid ${theme.borderLight}`, outline: 'none', 
    backgroundColor: isDisabled ? 'transparent' : '#fcfcfc' 
  };

  const cellStyle = { border: `1px solid ${theme.borderLight}`, padding: '0', margin: '0' };
  const cellInputStyle = { width: '100%', boxSizing: 'border-box', border: 'none', padding: '6px 4px', fontSize: '11px', backgroundColor: 'transparent', outline: 'none' };
  const readOnlyCell = { ...cellInputStyle, backgroundColor: '#f1f5f9', fontWeight: '600', color: theme.textMain };

  // --- DATA FETCHING ---
  const fetchBaseData = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const [supRes, medRes, indRes] = await Promise.all([
        fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliers?employee_id=${user.id}`),
        fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicines/all?employee_id=${user.id}`),
        fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/med-indent/pending?employee_id=${user.id}`)
      ]);
      setSuppliersList(await supRes.json() || []);
      setMedicinesList(await medRes.json() || []);
      setPendingIndents(await indRes.json() || []);
    } catch (e) { console.error("Error loading base data", e); }
  };

  const fetchNextId = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/medicine-po/id?employee_id=${user.id}`);
    const data = await res.json();
    setHeader(prev => ({ ...prev, po_number: data.po_number }));
  };

  useEffect(() => { fetchBaseData(); fetchNextId(); }, []);

  // --- CALCULATIONS ---
  useEffect(() => {
    let t_pur = 0, t_disc = 0, t_gst = 0, t_net = 0;
    lines.forEach(l => {
      t_pur += parseFloat(l.purchase_amount) || 0;
      t_disc += parseFloat(l.discount_amount) || 0;
      t_gst += parseFloat(l.gst_amount) || 0;
      t_net += parseFloat(l.line_total) || 0;
    });
    setHeader(prev => ({
      ...prev,
      total_purchase_amount: t_pur.toFixed(2),
      total_discount_amount: t_disc.toFixed(2),
      total_gst_amount: t_gst.toFixed(2),
      net_amount: t_net.toFixed(2)
    }));
  }, [lines]);

  const handleHeaderChange = (e) => setHeader({ ...header, [e.target.name]: e.target.value });

  // 🔥 HANDLE INDENT SELECTION
  // const handleIndentSelect = async (e) => {
  //   const indNo = e.target.value;
  //   setHeader({ ...header, indent_number: indNo });
  //   if (!indNo) return setLines([initLine]);

  //   try {
  //     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-indent/${indNo}`);
  //     const data = await res.json();
      
  //     if(data.header) {
  //       setHeader(prev => ({ ...prev, supplier_name: data.header.supplier_name || "" }));
        
  //       const mappedLines = data.details.map(d => {
  //         const pendQty = parseFloat(d.pending_qty) || 0;
  //         const rate = parseFloat(d.purchase_rate) || 0;
  //         const purAmt = pendQty * rate;

  //         return {
  //           ...initLine,
  //           medicine_id: d.medicine_id,
  //           medicine_name: d.medicine_name,
  //           unit: d.unit,
  //           indent_qty: pendQty,       // Show pending indent qty
  //           max_allowed_qty: pendQty,  // Set the max limit
  //           quantity: pendQty,         // Auto-fill PO Qty with remaining Indent Qty
  //           purchase_rate: rate,
  //           purchase_amount: purAmt.toFixed(2),
  //           line_total: purAmt.toFixed(2)
  //         };
  //       });
  //       setLines(mappedLines);
  //     }
  //   } catch (err) { console.error("Failed to load Indent details"); }
  // };

  // 🔥 UPDATE THIS FUNCTION IN YOUR PurchaseOrderMedicines.jsx
  const handleIndentSelect = async (e) => {
    const indNo = e.target.value;
    setHeader({ ...header, indent_number: indNo });
    if (!indNo) return setLines([initLine]);

    try {
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-indent/${indNo}`);
      const data = await res.json();
      
      if(data.header) {
        setHeader(prev => ({ ...prev, supplier_name: data.header.supplier_name || "" }));
        
        const mappedLines = data.details.map(d => {
          const pendQty = parseFloat(d.pending_qty) || 0;
          const rate = parseFloat(d.purchase_rate) || 0;
          const mrp = parseFloat(d.mrp) || 0;
          const gst = parseFloat(d.gst_percent) || 0;
          
          const purAmt = pendQty * rate;
          const taxable = purAmt; // Assuming no default discount
          const gstAmt = taxable * (gst / 100);
          const lineTotal = taxable + gstAmt;

          return {
            ...initLine,
            medicine_id: d.medicine_id,
            medicine_name: d.medicine_name,
            unit: d.unit,
            indent_qty: pendQty,       
            max_allowed_qty: pendQty,  
            quantity: pendQty,         
            purchase_rate: rate,
            mrp: mrp,                  // 🔥 Auto-fills MRP
            gst_percent: gst,          // 🔥 Auto-fills GST
            purchase_amount: purAmt.toFixed(2),
            gst_amount: gstAmt.toFixed(2),
            line_total: lineTotal.toFixed(2)
          };
        });
        setLines(mappedLines);
      }
    } catch (err) { console.error("Failed to load Indent details"); }
  };

  const handleLineChange = (index, field, value) => {
    const updated = [...lines];
    const row = updated[index];
    
    // 🔥 Validation: Cannot order more than Indent Qty
    if (field === "quantity" && row.max_allowed_qty !== null) {
      if (parseFloat(value) > row.max_allowed_qty) {
        alert(`Cannot exceed Pending Indent Qty of ${row.max_allowed_qty}`);
        row.quantity = row.max_allowed_qty;
      } else {
        row.quantity = value;
      }
    } else {
      row[field] = value;
    }

    if (field === "medicine_id") {
      const med = medicinesList.find(m => m.medicine_id === value);
      if (med) {
        row.medicine_name = med.medicine_name;
        row.purchase_rate = med.purchase_price;
        row.mrp = med.mrp;
        row.gst_percent = med.gst_percentage;
      }
    }

    const qty = parseFloat(row.quantity) || 0;
    const rate = parseFloat(row.purchase_rate) || 0;
    const discPct = parseFloat(row.discount_percent) || 0;
    const gstPct = parseFloat(row.gst_percent) || 0;

    row.purchase_amount = (qty * rate).toFixed(2);
    row.discount_amount = (row.purchase_amount * (discPct / 100)).toFixed(2);
    
    const taxableAmount = row.purchase_amount - row.discount_amount;
    row.gst_amount = (taxableAmount * (gstPct / 100)).toFixed(2);
    row.line_total = (taxableAmount + parseFloat(row.gst_amount)).toFixed(2);

    updated[index] = row;
    setLines(updated);
  };

  const addRow = () => setLines([...lines, { ...initLine }]);
  const removeRow = (index) => setLines(lines.filter((_, i) => i !== index));

  const searchPO = async (text) => {
    setSearchText(text);
    if (text.length < 3) { setSearchResults([]); setShowDropdown(false); return; }
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/search?q=${text}&employee_id=${user.id}`);
    setSearchResults(await res.json());
    setShowDropdown(true);
  };

  // const selectPO = async (po) => {
  //   setSearchText(`${po.po_number} | ${po.supplier_name}`);
  //   setShowDropdown(false);
  //   const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/${po.po_number}`);
  //   const data = await res.json();
    
  //   if(data.header) {
  //     setHeader({ 
  //       ...data.header, 
  //       invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" 
  //     });
  //     setLines(data.details.length > 0 ? data.details.map(d => ({...d, expiry_date: d.expiry_date ? d.expiry_date.split('T')[0]:""})) : [initLine]);
  //   }
  //   if (screenAction === "edit") setIsDisabled(false);
  //   if (screenAction === "view") setIsDisabled(true);
  // };

const selectPO = async (po) => {
    setSearchText(`${po.po_number} | ${po.supplier_name}`);
    setShowDropdown(false);
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/${po.po_number}`);
    const data = await res.json();
    
    if(data.header) {
      setHeader({ 
        ...data.header, 
        invoice_date: data.header.invoice_date ? data.header.invoice_date.split('T')[0] : "" 
      });
      
      const mappedLines = data.details.map(d => {
        // Safe fallbacks just in case
        const currentPoQty = parseFloat(d.quantity) || 0;
        const indQty = parseFloat(d.indent_qty) || currentPoQty; 
        const totalOrderedSoFar = parseFloat(d.ordered_qty) || 0;

        // 🔥 Magic Math for Editing: 
        // Max Allowed = (Current PO Qty) + (Whatever is still pending in the indent)
        const pendingLeft = indQty - totalOrderedSoFar;
        const maxLimit = currentPoQty + pendingLeft;

        return {
          ...d, 
          indent_qty: indQty,             // Shows 100 in the UI
          quantity: currentPoQty,         // Shows 50 in the UI
          max_allowed_qty: maxLimit,      // Prevents user from entering > 100 during edit
          expiry_date: d.expiry_date ? d.expiry_date.split('T')[0] : ""
        };
      });

      setLines(mappedLines.length > 0 ? mappedLines : [initLine]);
    }
    
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };


  const clearForm = async () => {
    setHeader(initHeader); setLines([initLine]); setSearchText("");
    await fetchNextId();
    await fetchBaseData();
  };

useEffect(() => {
    if (screenAction === "add" || screenAction === "refresh") { 
      clearForm(); setIsDisabled(false); setIsApproveMode(false); 
    }
    if (screenAction === "edit") { setIsDisabled(false); setIsApproveMode(false); }
    if (screenAction === "view") { setIsDisabled(true); setIsApproveMode(false); }
    
    // 🔥 Remember that we are in approve mode!
    if (screenAction === "approve") { 
      setIsDisabled(true); 
      setIsApproveMode(true); 
    }
    
    if (screenAction === "print") printForm();
  }, [screenAction]);

  // useEffect(() => { if (triggerSave > 0 && screenAction === "save") handleSubmit(); }, [triggerSave]);

useEffect(() => { 
    if (triggerSave > 0) {
      if (screenAction === "save") handleSubmit();
      if (screenAction === "approve") handleApprove(); // 🔥 Added this condition
    }
  }, [triggerSave]);


  const handleSubmit = async () => {

if (isApproveMode) {
      return handleApprove();
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (!header.supplier_name) return alert("Supplier is required.");
    
    const validLines = lines.filter(l => l.medicine_id !== "");
    if (validLines.length === 0) return alert("Add at least one medicine line item.");

    const payload = { header: { ...header, created_by: user.id }, details: validLines, isEdit: !!header.created_at };
    
    try {
      const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
      });
      if (res.ok) {
        alert("Purchase Order Saved!");
        if (!payload.isEdit) clearForm();
      } else alert("Error saving PO");
    } catch (err) { alert("Network Error"); }
  };


  const handleApprove = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!header.po_number) return alert("Please search and select a Purchase Order to approve.");
    if (header.po_status === "Approved") return alert("This PO is already Approved or Completed.");

    try {
      const payload = {
        po_number: header.po_number,
        emp_id: user.id,
        net_amount: header.net_amount
      };

      const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/medicine-po/approve", {
        method: "POST", 
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(payload)
      });
      
      const data = await res.json();
      
      if (data.success) {
        alert(data.message);
        clearForm();
        setIsApproveMode(false); // 🔥 Reset mode after successful approval
      } else {
        alert(data.message); 
      }
    } catch (err) { 
      alert("Network Error during approval."); 
    }
  };

// --- PRINT FORM ---
  const printForm = () => {
    if (!header.po_number) return alert("Please select or save a Purchase Order to print.");
    const newWindow = window.open("", "", "width=1100,height=800");
    
    const htmlContent = `
      <html><head><title>PO - ${header.po_number}</title>
      <style>
        body { font-family: 'Segoe UI', Tahoma, sans-serif; padding: 30px; font-size: 12px; color: #333; }
        .title-box { display: flex; justify-content: space-between; border-bottom: 2px solid #282f81; padding-bottom: 10px; margin-bottom: 20px; }
        .title-box h1 { margin: 0; color: #282f81; }
        .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 15px; margin-bottom: 20px; background: #f8fafc; padding: 15px; border-left: 4px solid #11abea;}
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 11px; }
        th, td { border: 1px solid #ddd; padding: 6px 4px; text-align: left; }
        th { background-color: #f2f4f4; color: #282f81; }
        .totals-box { width: 300px; float: right; border: 1px solid #ddd; padding: 10px; border-radius: 4px; background: #f0fdf4; }
        .totals-row { display: flex; justify-content: space-between; margin-bottom: 5px; }
        .grand-total { font-weight: bold; font-size: 14px; border-top: 1px solid #ccc; padding-top: 5px; color: #11abea; }
      </style></head>
      <body>
        <div class="title-box">
          <div><h1>EMEDHA CARE HOSPITAL</h1><p>Pharmacy Purchase Order</p></div>
          <div style="text-align:right"><h2>${header.po_number}</h2><p>Date: ${new Date().toLocaleDateString()}</p></div>
        </div>
        <div class="info-grid">
          <div><strong>Supplier:</strong><br/>${header.supplier_name}</div>
          <div><strong>Linked Indent:</strong><br/>${header.indent_number || 'Direct PO (No Indent)'}</div>
          <div><strong>Invoice No / Date:</strong><br/>${header.invoice_number || '-'} <br/> ${header.invoice_date || '-'}</div>
          <div><strong>Payment Mode:</strong><br/>${header.payment_mode || '-'}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>SI</th><th>Medicine Name</th><th>Unit</th>
              <th style="color: #e84118;">Ind Qty</th><th style="color: #11abea;">PO Qty</th><th>Free</th>
              <th>Pur Rate</th><th>Pur Amt</th><th>MRP</th><th>Disc%</th><th>Disc Amt</th>
              <th>GST%</th><th>GST Amt</th><th>Expiry</th><th>Line Total</th>
            </tr>
          </thead>
          <tbody>
            ${lines.map((l, i) => `
              <tr>
                <td>${i + 1}</td><td>${l.medicine_name}</td><td>${l.unit}</td>
                <td style="color:#e84118; font-weight:bold;">${l.indent_qty || '-'}</td>
                <td style="color:#11abea; font-weight:bold;">${l.quantity}</td>
                <td>${l.free_quantity}</td>
                <td>₹${l.purchase_rate}</td><td>₹${l.purchase_amount}</td><td>₹${l.mrp}</td>
                <td>${l.discount_percent}%</td><td>₹${l.discount_amount}</td>
                <td>${l.gst_percent}%</td><td>₹${l.gst_amount}</td><td>${l.expiry_date}</td>
                <td><strong>₹${l.line_total}</strong></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <div class="totals-box">
          <div class="totals-row"><span>Total Purchase Amt:</span><span>₹${header.total_purchase_amount}</span></div>
          <div class="totals-row"><span>Total Discount Amt:</span><span>₹${header.total_discount_amount}</span></div>
          <div class="totals-row"><span>Total GST Amt:</span><span>₹${header.total_gst_amount}</span></div>
          <div class="totals-row grand-total"><span>Net Amount:</span><span>₹${header.net_amount}</span></div>
        </div>
        
        <div style="clear:both; margin-top: 80px; display: flex; justify-content: space-between; width: 60%;">
          <div style="border-top: 1px solid #000; width: 150px; text-align:center; padding-top: 5px;">Prepared By</div>
          <div style="border-top: 1px solid #000; width: 150px; text-align:center; padding-top: 5px;">Authorized Signatory</div>
        </div>
      </body></html>
    `;
    newWindow.document.write(htmlContent); newWindow.document.close();
    setTimeout(() => { newWindow.print(); newWindow.close(); }, 500);
  };

  return (
    <div className="registration-container fade-in" style={{ backgroundColor: theme.bgLight, padding: '10px' }}>
      
      {(screenAction === "edit" || screenAction === "view" || screenAction === "approve") && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <div style={{ position: 'relative', width: '350px' }}>
            <input type="text" value={searchText} placeholder="Search PO No, Supplier, Invoice..." onChange={(e) => searchPO(e.target.value)}
              style={{ width: '100%', padding: '10px 16px', borderRadius: '8px', border: `1px solid ${theme.borderLight}`, outline: 'none' }} />
            {showDropdown && searchResults.length > 0 && (
              <div style={{ position: 'absolute', top: '110%', left: '0', width: '100%', background: theme.cardBg, borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '250px', overflowY: 'auto' }}>
                {searchResults.map(p => (
                  <div key={p.po_number} onClick={() => selectPO(p)} style={{ padding: '10px', borderBottom: `1px solid ${theme.borderLight}`, cursor: 'pointer' }}>
                    <strong>{p.po_number}</strong> <br/><span style={{ fontSize: '12px', color: theme.textMuted }}>{p.supplier_name} | {p.invoice_number}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <form className="luxury-form" style={{ padding: '15px 20px' }}>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', paddingBottom: '15px', borderBottom: `2px solid ${theme.primaryDark}`, marginBottom: '15px' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>PO Number:</div>
              <input type="text" name="po_number" value={header.po_number} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue}} />
            </div>
            <div style={compactRowStyle}>
              <div style={{...compactLabelStyle, color: theme.accentCyan}}>Link Indent No:</div>
              <select name="indent_number" value={header.indent_number} onChange={handleIndentSelect} disabled={isDisabled || header.created_at} style={compactInputStyle}>
                <option value="">-- No Indent (Direct PO) --</option>
                {pendingIndents.map((ind, i) => <option key={i} value={ind.indent_number}>{ind.indent_number} ({ind.location_name})</option>)}
              </select>
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Supplier Name:</div>
              <select name="supplier_name" value={header.supplier_name} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
                <option value="">Select Supplier...</option>
                {suppliersList.map((s, i) => <option key={i} value={s.Supp_Nm}>{s.Supp_Nm}</option>)}
              </select>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Invoice No:</div>
              <input type="text" name="invoice_number" value={header.invoice_number} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Invoice Date:</div>
              <input type="date" name="invoice_date" value={header.invoice_date} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Payment Mode:</div>
              <select name="payment_mode" value={header.payment_mode} onChange={handleHeaderChange} disabled={isDisabled} style={compactInputStyle}>
                <option value="">Select</option><option>Cash</option><option>Card</option><option>UPI</option><option>Credit</option>
              </select>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Purchase Amt:</div>
              <input type="text" value={header.total_purchase_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9', textAlign: 'right'}} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Discount Amt:</div>
              <input type="text" value={header.total_discount_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9',textAlign: 'right'}} />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>GST Amt:</div>
              <input type="text" value={header.total_gst_amount} disabled style={{...compactInputStyle, backgroundColor: '#f1f5f9',textAlign: 'right'}} />
            </div>
            <div style={compactRowStyle}>
              <div style={compactLabelStyle}>Net Amount:</div>
              <input type="text" value={header.net_amount} disabled style={{...compactInputStyle, fontWeight: 'bold', color: theme.primaryBlue, backgroundColor: '#e0e7ff', textAlign: 'right'}} />
            </div>
          </div>

        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h3 style={{ margin: 0, fontSize: '15px', color: theme.primaryDark }}>Line Items</h3>
          {!isDisabled && <button type="button" onClick={addRow} style={{ background: theme.primaryBlue, color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>+ Add Row</button>}
        </div>
        
        <div style={{ overflowX: 'auto', border: `1px solid ${theme.borderLight}`, marginBottom: '10px' }}>
          <table style={{ width: '100%', minWidth: '1600px', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead style={{ backgroundColor: theme.primaryDark, color: '#fff' }}>
              <tr>
                <th style={{ ...cellStyle, padding: '6px', width: '30px', textAlign: 'center' }}>SI</th>
                <th style={{ ...cellStyle, padding: '6px', width: '100px' }}>Medicine ID</th>
                <th style={{ ...cellStyle, padding: '6px', width: '160px' }}>Medicine Name</th>
                <th style={{ ...cellStyle, padding: '6px', width: '60px' }}>Unit</th>
                <th style={{ ...cellStyle, padding: '6px', width: '60px', color: '#ffb8b8' }}>Ind Qty</th> {/* Indent Qty Column */}
                <th style={{ ...cellStyle, padding: '6px', width: '60px', color: theme.accentCyan }}>PO Qty</th>
                <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>Free</th>
                <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>Pur Rate</th>
                <th style={{ ...cellStyle, padding: '6px', width: '80px' }}>Pur Amt</th>
                <th style={{ ...cellStyle, padding: '6px', width: '60px' }}>MRP</th>
                <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>Disc%</th>
                <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>Disc Amt</th>
                <th style={{ ...cellStyle, padding: '6px', width: '50px' }}>GST%</th>
                <th style={{ ...cellStyle, padding: '6px', width: '70px' }}>GST Amt</th>
                <th style={{ ...cellStyle, padding: '6px', width: '110px' }}>Expiry Dt</th>
                <th style={{ ...cellStyle, padding: '6px', width: '90px' }}>Line Total</th>
                {!isDisabled && <th style={{ ...cellStyle, width: '30px' }}></th>}
              </tr>
            </thead>
            <tbody>
              {lines.map((line, idx) => (
                <tr key={idx} style={{ borderBottom: `1px solid ${theme.borderLight}` }}>
                  <td style={{ ...cellStyle, textAlign: 'center', fontWeight: 'bold' }}>{idx + 1}</td>
                  
                  <td style={cellStyle}>
                    <select value={line.medicine_id} onChange={(e) => handleLineChange(idx, 'medicine_id', e.target.value)} disabled={isDisabled || !!header.indent_number} style={{...cellInputStyle, backgroundColor: header.indent_number ? '#f1f5f9' : 'transparent'}}>
                      <option value=""></option>
                      {medicinesList.map(m => <option key={m.medicine_id} value={m.medicine_id}>{m.medicine_id}</option>)}
                    </select>
                  </td>
                  
                  <td style={cellStyle}><input type="text" value={line.medicine_name} disabled style={readOnlyCell} title={line.medicine_name} /></td>
                  
                  <td style={cellStyle}>
                    <select value={line.unit} onChange={(e) => handleLineChange(idx, 'unit', e.target.value)} disabled={isDisabled || !!header.indent_number} style={{...cellInputStyle, textAlign: 'center', backgroundColor: header.indent_number ? '#f1f5f9' : 'transparent'}}>
                      <option>Box</option><option>Strip</option><option>Loose</option>
                    </select>
                  </td>

                  {/* Indent Qty (Read Only) */}
                  <td style={cellStyle}><input type="text" value={line.indent_qty} disabled style={{...readOnlyCell, textAlign: 'right', color: '#e84118'}} /></td>
                  
                  <td style={cellStyle}><input type="number" value={line.quantity} onChange={(e) => handleLineChange(idx, 'quantity', e.target.value)} disabled={isDisabled} style={{...cellInputStyle, fontWeight: 'bold' , textAlign: 'right'}} /></td>
                  <td style={cellStyle}><input type="number" value={line.free_quantity} onChange={(e) => handleLineChange(idx, 'free_quantity', e.target.value)} disabled={isDisabled} style={{...cellInputStyle , textAlign: 'center'}} /></td>
                  <td style={cellStyle}><input type="number" value={parseFloat(line.purchase_rate).toFixed(2)} onChange={(e) => handleLineChange(idx, 'purchase_rate', e.target.value)} disabled={isDisabled} style={{...cellInputStyle, textAlign: 'right'}} /></td>
                  
                  <td style={cellStyle}><input type="text" value={line.purchase_amount} disabled style={{...readOnlyCell, textAlign: 'right'}} /></td>
                  
                  <td style={cellStyle}><input type="number" value={parseFloat(line.mrp).toFixed(2)} onChange={(e) => handleLineChange(idx, 'mrp', e.target.value)} disabled={isDisabled} style={{...cellInputStyle , textAlign: 'right'}} /></td>
                  <td style={cellStyle}><input type="number" value={line.discount_percent} onChange={(e) => handleLineChange(idx, 'discount_percent', e.target.value)} disabled={isDisabled} style={{...cellInputStyle ,textAlign:'center'}} /></td>
                  
                  <td style={cellStyle}><input type="text" value={line.discount_amount} disabled style={{...readOnlyCell , textAlign: 'right'}} /></td>
                  
                  <td style={cellStyle}><input type="number" value={line.gst_percent} onChange={(e) => handleLineChange(idx, 'gst_percent', e.target.value)} disabled={isDisabled} style={{...cellInputStyle , textAlign: 'right'}} /></td>
                  
                  <td style={cellStyle}><input type="text" value={line.gst_amount} disabled style={{...readOnlyCell, textAlign: 'right'}} /></td>
                  
                  <td style={cellStyle}><input type="date" value={line.expiry_date} onChange={(e) => handleLineChange(idx, 'expiry_date', e.target.value)} disabled={isDisabled} style={cellInputStyle} /></td>
                  
                  <td style={cellStyle}><input type="text" value={line.line_total} disabled style={{...readOnlyCell, color: theme.primaryBlue , textAlign: 'right'}} /></td>
                  
                  {!isDisabled && <td style={{ ...cellStyle, textAlign: 'center' }}><button type="button" onClick={() => removeRow(idx)} style={{ color: 'red', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 'bold' }}>X</button></td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
};

export default PurchaseOrderMedicines;